export const environment = {
    production: false,
    apiProfile: '/api/v1/users/whoami',
    apiLogout: '/api/v1/auth/logout',

    
    PERMISSIONS:  {
        STUDIES_APP: "study_management.studies_list",
        CONF_APP: "enclave_config.view_config",
        INBOX_APP: "inbox.view_inbox",
        DATA_INGRESS: "data_ingestion.view_ingress_module",
        SHARE_DATASET: "data_ingestion.share_dataset",
        EDIT_METADATA: "data_ingestion.edit_metadata",
        DATA_CATALOG: "data_catalog.view_catalog_module",
        //Studies
        CREATE_STUDY: "study_management.create_study",
        CREATE_SUB_STUDY: "study_management.create_sub_study",  
        STUDY_DETAILS: "study_details.view_study_details",

        //Data Ingestion
        DATA_INGRESS_UPLOAD_FILE:"data_ingestion.upload_files",
        SHARE_INGRESS_DATASET:"data_ingestion.share_dataset",
        EDIT_DATASET:"data_ingestion.edit_dataset",
        //Analytics
        STUDY_ANALYTICS: "study_analytics.view_analytics_module",
        STUDY_ANALYTICS_ACCESS_HPC: "study_analytics.access_hpc",
        STUDY_ANALYTICS_MANAGE_EC2_JPY_SELF: "study_analytics.manage_ec2_jupyter_instance_self",
        STUDY_ANALYTICS_MANAGE_EC2_JPY_OTHERS: "study_analytics.manage_ec2_jupyter_instance_others",
        STUDY_ANALYTICS_TERMINATE_INSTANCE: "study_analytics.terminate_ec2_jupyter_others",
        STUDY_ANALYTICS_SAGEMAKER: "study_analytics.access_sagemaker_apps",
        STUDY_ANALYTICS_CLOUD9: "study_analytics.access_cloud9",
        STUDY_ANALYTICS_NFT_MAINTAIN: "study_analytics.nft_maintain_role",
        STUDY_ANALYTICS_NFT_LAUNCH: "study_analytics.nft_launch_role",
        STUDY_ANALYTICS_HO_CREATE: "study_analytics.health_omics_create_run_workflow",
        STUDY_ANALYTICS_HO_RUN: "study_analytics.health_omics_run_workflow",
        STUDY_ANALYTICS_POSIT: "study_analytics.access_posit",
        STUDY_ANALYTICS_POSIT_WITH_REQUEST_FOR_ROLE: "study_analytics.access_posit_request_role",
        STUDY_ANALYTICS_HALO: "study_analytics.access_halo",
        STUDY_ANALYTICS_MANAGE_HPC: "study_analytics.manage_hpc",
        STUDY_ANALYTICS_CREATE_CUSTOM_HPC: "study_analytics.create_custom_hpc",
        STUDY_ANALYTICS_EC2_LARGE_SIZE: "study_analytics.ec2_large_size_instance",
        STUDY_ANALYTICS_EC2_START_STOP_TERMINATE_BY_OTHERS:"study_analytics.ec2_start_stop_terminate",
        STUDY_ANALYTICS_JPY_START_STOP_TERMINATE_BY_OTHERS:"study_analytics.jupyter_start_stop_terminate",
        STUDY_ANALYTICS_CUSTOM_HPC:"study_analytics.create_custom_hpc",
        //Members
        STUDY_MEMBERS: "study_members.view_members",
        STUDY_MEMBERS_INVITE: "study_members.invite_member",
        STUDY_MEMBERS_EDIT:"study_members.edit_member",
        STUDY_MEMBERS_REMOVE: "study_members.remove_member",

        //Budget
        STUDY_BUDGET: "study_budget.study_budget_module",
        STUDY_BUDGET_EDIT: "study_budget.view_edit_study_budget",

        //Apps
        STUDY_APPS: "study_members.view_members",        
        
        //Study Settings
        STUDY_SETTINGS: "settings.settings_module",
        STUDY_SETTINGS_MANAGE: "settings.manage_application",

        //catalog
        CATALOGUE_SEARCH: "data_catalog.search_catalog",
        CATALOGUE_EDIT_METADATA:"data_catalog.edit_metadata",

        //App Hosting
        APP_HOSTING: "app_hosting.app_hosting_module",
        APP_HOSTING_MANAGE:"app_hosting.manage_application",
        APP_HOSTING_SHOW: false
    },
    ENC_ADMIN: 'ADMIN',
    ENC_CONF: {
        NFT: 'nft',
        ANALYTICS: 'analytics',
        POSIT_CONNECT: 'posit_connect',
        SAGE_MAKER:  'sageMakerApps',
        SAGE_MAKER_WITH_JUPYTER: 'sageMakerWithJupyter',
        HPC: 'hpc',
        FSX: 'fsx',
        BYOPCLOUD9: 'byopAndCloud9',
        CODEARTIFACT: 'codeArtifact',
        CODECOMMIT: 'codeCommit',
        ECR: 'ecr',
        COMPUTE: 'compute',
        ENC_BASE: 'enclave_base',
        STATUS_CONFIGURED: 'CREATED',
        STATUS_INPROGRESS: 'INPROGRESS',
        STATUS_NOT_CONFIGURED: 'NO',
        STATUS_FAILED:'FAILED'
    },
    STUDY: {
        STATUS_CREATED: 'CREATED',
        STATUS_INPROGRESS: 'INPROGRESS',
        STATUS_FAILED: 'FAILED'
    },

    // enclave-base-management-service
    enclaveDetails: 'enclave-base-management-service/api/v1/enclave',
    enclavePutAPI: 'enclave-base-management-service/api/v1/enclaves',
    endorConfigApi: 'enclave-base-management-service/api/v1/enclave/config/endorUrl/contents',
    configApi: 'enclave-base-management-service/api/v1/enclave/appconfig/config',
    featureApi: 'enclave-base-management-service/api/v1/enclave/feature',
    deleteFeatureApi: 'enclave-base-management-service/api/v1/enclave/feature',
    permissionsAPi: 'enclave-base-user-management-service/api/v1/enclave/permissions',
    rolesApi: 'enclave-base-user-management-service/api/v1/enclave/role',
    ingressApi: 'enclave-base-data-ingestion-service/api/v1/datasets',
    shareDatasetsApi:'enclave-base-data-ingestion-service/api/v1/shareddatasets',
    downloadSchema: 'enclave-base-data-ingestion-service/api/v1/schema/download/template',
    downloadTemplate: 'enclave-base-data-ingestion-service/api/v1/schema/download/default',
    updateUser: 'enclave-base-user-management-service/api/v1/enclave/user/entry',
    configPage:'enclave-base-management-service/api/v1/settings/master',
    
    //study
    studyApi: "enclave-base-study-management-service/api/v1/study",
    subStudyApi: "enclave-base-study-management-service/api/v1/subStudy",
    validateStudyApi: "enclave-base-study-management-service/api/v1/study/validate",
    ingressSchemaApi:"enclave-base-data-ingestion-service/api/v1/schema",
    catalogServiceApi: "enclave-base-catalog-service/api/v1",
    createMetaDataApi: "enclave-base-data-ingestion-service/api/v1/metadata",
    nftLogin: "enclave-base-study-management-service/api/v1/nftlogin",
    sFTPURL: "enclave-base-study-management-service/api/v1/study/infra/resourcedetail/",
    validateEndorToken: "enclave-base-data-ingestion-service/api/v1/eln/fetchmetadataattributes",
    endorLogin:"enclave-base-user-management-service/api/v1/endor/login",
    datasetSubmit: 'enclave-base-data-ingestion-service/api/v1/sharedatasets',
    positConnect:'enclave-base-study-management-service/api/v1/study/posit',
    
    // Data Ingress
    dataset: 'enclave-base-data-ingestion-service/api/v1/dataset',
    copyDataset: 'enclave-base-data-ingestion-service/api/v1/dataset/copy',
    provideReason: 'enclave-base-data-ingestion-service/api/v1/imageqc/skipqc',
    addFiles: 'enclave-base-data-ingestion-service/api/v1/dataset/file',
    listFiles: "enclave-base-data-ingestion-service/api/v1/sftpfiles",    
    listSyncFiles: "enclave-base-data-ingestion-service/api/v1/datasyncfiles",
    fileListResponse: "enclave-base-data-ingestion-service/api/v1/files",
    imageQCResult: "enclave-base-data-ingestion-service/api/v1/imageqc/imageqcreport",
    filesAndFolders:"enclave-base-data-ingestion-service/api/v1/filesandfolders",
    filesFromSearch:"enclave-base-data-ingestion-service/api/v1/daterangesearch",
    getImageLink: "enclave-base-data-ingestion-service/api/v1/imagepresignedlink",
    getQCDetails: "enclave-base-data-ingestion-service/api/v1/imageqc/qcfilestatus",
    dataIngressFileUpload: 'enclave-base-data-ingestion-service/api/v1/filemanagement/upload',
    dataIngressCompleteMultiPart: 'enclave-base-data-ingestion-service/api/v1/filemanagement/completeupload',
    saveIngress: "enclave-base-data-ingestion-service/api/v1/dataset/metadata",
    getSchemaList: "enclave-base-data-ingestion-service/api/v1/schemas",
    getRedCapSchemaList: "enclave-base-data-ingestion-service/api/v1/redcap-schema",
    getSchemaData: "enclave-base-data-ingestion-service/api/v1/schema",
    updateMetaSchemas:"enclave-base-data-ingestion-service/api/v1/schema/nodeschemas",
    dataIngressGetMetadata:"enclave-base-data-ingestion-service/api/v1/dataset",
    dataIngressSubmit:"enclave-base-data-ingestion-service/api/v1/dataset/submit",
    inbox:"enclave-base-data-ingestion-service/api/v1/inboxmanagement/inbox",
    analyticsInstance: "enclave-base-study-management-service/api/v1/study",
    instarnceSize: "enclave-base-management-service/api/v1/enclave/config",
    userManualApi: "enclave-base-management-service/api/v1/enclave/config/userManual/contents",
    fileUploadForMetadata: "enclave-base-data-ingestion-service/api/v1/dataset/uploadnewschema",
    analyticsInstanceLaunch: 'studyinternal/enclave-base-study-management-service/api/v1/study',
    analyticsPagePermission:'enclave-base-management-service/api/v1/settings',
    qckitingestion: "enclave-base-data-ingestion-service/api/v1/qcpreingestion/dataset",
    sendFilesForQCCheck:"enclave-base-data-ingestion-service/api/v1/imageqc/qcdataset",
    getQCResult:'enclave-base-data-ingestion-service/api/v1/imageqc/qcimagefiles',
    sendFilesForQCOverridepass:'enclave-base-data-ingestion-service/api/v1/imageqc/overridepass',
    getpostQCimageLink: "enclave-base-data-ingestion-service/api/v1/imageqc/postqcimagepresignedurl",
    getdraftFileStatus:"enclave-base-data-ingestion-service/api/v1/imageqc/draftflow",
    discardQC:"enclave-base-data-ingestion-service/api/v1/imageqc/discard",
    downloadQCCSV:"enclave-base-data-ingestion-service/api/v1/imageqc/csv/report/download",
    // dataIngressFailedNotificationApi: 'enclave-base-data-ingestion-service/api/v1/filemanagement/completeupload',
    jupyterInstance: "enclave-base-study-management-service/api/v1/manageJupyterInstance",

    //Members
    inviteNewMemberApi:"enclave-base-user-management-service/api/v1/enclave/user/invite",
    inviteExistingMemberApi:"enclave-base-user-management-service/api/v1/enclave/users",
    memberDetailsByEmailApi:"enclave-base-user-management-service/api/v1/email",
    viewMemberApi:"enclave-base-user-management-service/api/v1/enclave/study/members",
    membersListApi:"enclave-base-user-management-service/api/v1/users/ENCLAVE",
    editMemberApi:"enclave-base-user-management-service/api/v1/enclave/user",
    excludeCurrentroleApi:"enclave-base-user-management-service/api/v1/enclave/study/role",
    getRoleByType:"enclave-base-user-management-service/api/v1/enclave/role/roleType",
    
    //rolePermissions
    rolePermissions: "enclave-base-user-management-service/api/v1/enclave/user/rolepermission",

    //sFTP
    sfTPDetails: "enclave-base-security-service/api/v1/detail",

    //catalogue
    catalogueDetails: "enclave-base-catalog-service/api/v1/publish/customsearch",

    //TermsAndCondition
    TermsandConditionDetails:"enclave-base-user-management-service/api/v1/termsandconditions",

    //budget
    budget: "enclave-base-study-management-service/api/v1/budgets",
    budgetByStudy: "enclave-base-study-management-service/api/v1/budget/usage",
    costDashboard: "enclave-base-study-management-service/api/v1/costdashboard",
    updateBudget: "enclave-base-study-management-service/api/v1/study",
    
    //csi
    csiDetails: 'enclave-base-study-management-service/api/v1/csi',

    oauth2Config: {
        authorizeUrl: 'https://api.appdevus.platform.navify.com/api/v1/auth/protocols/oidc/authorize',
        startUrl: 'enclave-base-security-service/api/auth/oauth2/start',
        exchangeUrl: 'enclave-base-security-service/api/auth/oauth2/exchange',
        refreshUrl: 'enclave-base-security-service/api/auth/oauth2/refresh',
        logoutUrl: 'enclave-base-security-service/api/auth/oauth2/logout',
        autoTriggerOnLogin: true
    },

    
};
